import { stringify } from 'query-string';

const paramsToSearch = (params: Parameters<typeof stringify>[0]) => {
  return `?${stringify(params).replace(/%20/g, '+')}`;
};

export default paramsToSearch;
